const gallery = {
  allDesigns: "כל העיצובים",
  preview: "תצוגה מקדימה",
  openDesign: "פתח עיצוב",
  backToGallery: "חזרה לגלריה",
  noDesigns: "אין עיצובים עדיין",
  route: "נתיב",
  createdAt: "נוצר",
  tags: "תגיות",
  landing: "דף נחיתה",
  website: "אתר",
  dashboard: "דשבורד",
  component: "רכיב",
} as const;
export default gallery;
